export default __webpack_public_path__ + "static/media/featured_area_vaughan.00b53b2a.webp";